import styled from 'styled-components';
import { color, typography, compose } from 'styled-system';

export const H1 = styled.h1`
  font-size: 2em;
  text-align: center;
  
  ${compose(color, typography)}
`

export const H2 = styled.h2`
  font-size: 1.5em;
  text-align: center;
  margin-bottom: 1em;

  ${compose(color, typography)}
`

export const H3 = styled.h3`
  font-size: 1.25em;
  
  ${compose(color, typography)}
`